import { render } from "./annual-report-inc.vue?vue&type=template&id=270e0286&scoped=true"
import script from "./annual-report-inc.vue?vue&type=script&lang=js"
export * from "./annual-report-inc.vue?vue&type=script&lang=js"

import "./annual-report-inc.vue?vue&type=style&index=0&id=270e0286&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/thinkcloud/thinkcloud-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270e0286"]])

export default __exports__